import { useTranslation } from 'react-i18next'
import { ListCars } from '~/features/africa/Cars/ListCars'
import { Container, PageContainer } from '~/shared/ui/Layout'

export function ListCarsPageAfrica() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('cars')}>
      <Container>
        <ListCars />
      </Container>
    </PageContainer>
  )
}
